import React, { useEffect } from 'react';
import './NotificationWrapper.scss';

type ToastProps = {
  message: string;
  id: number;
  isCalendarNotification?: boolean;
  isStyled?: boolean;
  onRemove: (id: number) => void;
};

const TOAST_TEXT_CLASSES = 'text-center font-size-14px font-weight-500';

const NotificationWrapper: React.FC<ToastProps> = ({ message, id, onRemove, isCalendarNotification, isStyled }: ToastProps): JSX.Element => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onRemove(id);
    }, 3000);

    return () => clearTimeout(timer);
  }, [id, onRemove]);

  return (
    <div className="toast">
      {isCalendarNotification
        ? (
          <div className={TOAST_TEXT_CLASSES}>
            We have emailed you a calendar invite {message ? 'for' : null} <strong>{message}</strong>.
            <br />
            Any changes to the schedule will stay up to date on your calendar.
          </div>
        )
        : isStyled
          ? (
            <div className={TOAST_TEXT_CLASSES}>
              {message}
            </div>
          )
          : (
            message
          )}
    </div>
  );
};

export default NotificationWrapper;